import api from "../../domain/api";
import {
    GET_CAREERS_STATED,
    GET_CAREERS,
    GET_CAREERS_ENDED,
    ADD_CAREER_STATED,
    ADD_CAREER,
    ADD_CAREER_ENDED,
    EDIT_CAREER_STATED,
    EDIT_CAREER,
    EDIT_CAREER_ENDED,
    GET_CAREER_STATED,
    GET_CAREER,
    GET_CAREER_ENDED,
    GET_ALL_CAREERS_STATED,
    GET_ALL_CAREERS,
    GET_ALL_CAREERS_ENDED,
} from "../types/career_type";
import * as qs from "qs";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";

export const addCareer = (formData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: ADD_CAREER_STATED,
        });
        const { data } = await api.post(`/careers`, formData);
        dispatch({
            type: ADD_CAREER,
            payload: data,
        });
        dispatch({
            type: ADD_CAREER_ENDED,
        });
    } catch (error) {
        dispatch({
            type: ADD_CAREER_ENDED,
        });
        dispatch(handleErrorLocal(error));
        dispatch(handleError(error));
    }
};
export const getCareers =
    ({ pageNumber = "" }) =>
        async (dispatch) => {
            try {
                dispatch({
                    type: GET_CAREERS_STATED,
                });
                const queryParams = qs.parse(window.location.search.replace("?", ""));
                const query = qs.stringify(queryParams, {
                    encodeValuesOnly: true, // prettify url
                });

                const { data } = await api.get(`/careers?&${query}`);

                dispatch({
                    type: GET_CAREERS,
                    payload: data,
                });
                dispatch({
                    type: GET_CAREERS_ENDED,
                });
            } catch (error) {
                dispatch({
                    type: GET_CAREERS_ENDED,
                });
                dispatch(handleErrorLocal(error));
                dispatch(handleError(error));
            }
        };
export const getCareer = (id) => async (dispatch) => {
    try {
        dispatch({
            type: GET_CAREER_STATED,
        });
        const { data } = await api.get(`/careers/${id}`);

        dispatch({
            type: GET_CAREER,
            payload: data,
        });
        dispatch({
            type: GET_CAREER_ENDED,
        });
    } catch (error) {
        dispatch({
            type: GET_CAREER_STATED,
        });
        dispatch(handleErrorLocal(error));
        dispatch(handleError(error));
    }
};
export const editCareer = (id, formData) => async (dispatch) => {
    try {
        dispatch({
            type: EDIT_CAREER_STATED,
        });
        const { data } = await api.put(`/careers/${id}`, formData);
        dispatch({
            type: EDIT_CAREER,
            payload: data,
        });
        dispatch({
            type: EDIT_CAREER_ENDED,
        });
    } catch (error) {
        dispatch({
            type: EDIT_CAREER_ENDED,
        });
        dispatch(handleErrorLocal(error));
        dispatch(handleError(error));
    }
};
export const deleteCareer = (id) => async (dispatch) => {
    try {
        const { data } = await api.delete(`/careers/${id}`);
        dispatch(setAlert("Career Deleted Successfully", "success"));
    } catch (error) {
        dispatch(handleErrorLocal(error));
        dispatch(handleError(error));
    }
};
export const getAllCareers =
    ({ term, value }) =>
        async (dispatch) => {
            try {
                dispatch({
                    type: GET_ALL_CAREERS_STATED,
                });
                const { data } = await api.get(
                    `/careers/all?term=${term}&value=${value}`
                );

                dispatch({
                    type: GET_ALL_CAREERS,
                    payload: data,
                });
                dispatch({
                    type: GET_ALL_CAREERS_ENDED,
                });
            } catch (error) {
                dispatch({
                    type: GET_ALL_CAREERS_ENDED,
                });
                dispatch(handleErrorLocal(error));
                dispatch(handleError(error));
            }
        };

export const handleErrorLocal = () => async (dispatch) => { };
